import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { User } from '@app/models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { CompanyInfoModalComponent } from '@shared/modals';
import { LocalStorage } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { filter, first, take } from 'rxjs/operators';
import { CompanyService } from '@app/services';
import { environment } from '@env/environment';


@Injectable()
export class LogoutGuardService implements CanActivate {
  @LocalStorage() companyInfoModalOpen;
  @LocalStorage() organizationId;
  user$: Observable<User>;
  currentUser: User;
  isLoggingOut: boolean = false;
  isRCDSS = environment.name === 'rcdss';

  constructor(
    private store: Store<{ user: User }>,
    private $company: CompanyService,
    private modalService: NgbModal,
    protected router: Router,
  ) {
    this.user$ = this.store.select('user');
    this.user$
      .pipe(take(1))
      .subscribe((user) => {
        this.currentUser = (user as User);
      });
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): 
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.isLoggingOut) {
      this.isLoggingOut = false;
      return true;
    }
    if (this.currentUser && !this.companyInfoModalOpen && !this.isRCDSS) {
      this.isLoggingOut = true;
      this.$company.shouldRequestInfo(this.organizationId).subscribe(res => {
        console.log(res);
        if (res.should_request_info === true) {
          this.openCompanyInfoModal().then(() => {
            this.router.navigate([state.url]);
          });
        } else {
          this.router.navigate([state.url]);
        }
      });
      return false;
    }
    this.isLoggingOut = false;
    return true;
  }

  openCompanyInfoModal() {
    const activeModal = this.modalService.open(CompanyInfoModalComponent, {
      size: 'lg',
      container: 'nb-layout',
      backdrop: 'static',
      keyboard: false,
    });
    activeModal.componentInstance.user = this.currentUser;
    return activeModal.result;
  }

}
